export const prestashopUserGuideContent = {
  es: `
## Guía de Usuario del Conector Data Lab

#### ¿Qué hace el conector de Data Lab?

- El Conector de Data Lab accede a la base de datos de Prestashop de tu tienda para recuperar métricas de tráfico diarias y eventos de ecommerce.
- Todos los datos son completamente procesados y anonimizados por el módulo antes de poder salir de tu tienda, garantizando que ningún dato sensible abandone tu tienda en ningún momento del proceso.
- Una vez conectado a Data Lab, puedes analizar tus métricas en la plataforma para conocer mejor tu tienda y sus ventas: descubre en qué momentos vendes más, dónde envías habitualmente o compara en qué época del año tus carritos se convierten mejor en ventas.
- Puedes revocar el acceso en cualquier momento que desees. Tu tienda, tu libertad.

#### ¿Quién puede ver mis datos desde Data Lab?

Los datos de tu tienda solo los ves tú. Data Lab únicamente muestra tres tipos de datos a sus usuarios:

- Sus datos personales (los de su propia tienda, nadie más puede verlos)
- Datos públicos (de fuentes disponibles públicamente, cualquiera puede verlos)
- Agregaciones: cuando contamos con un número considerable de fuentes y los datos no pueden rastrearse de ninguna forma, Data Lab realiza agregaciones para que cualquiera pueda compararse con el resto de su sector de forma privada. Cualquier usuario que contribuya a una agregación puede ver los datos agregados, pero nunca los de una tienda concreta (excepto los propios).

#### Antes de instalar

- Asegúrate de estar registrado en Data Lab.
- Para que las métricas de tu tienda se comparen con precisión con las del sector, puedes configurar una Actividad Principal para tu tienda antes de instalar el módulo.
  Puedes encontrar esta configuración en el panel de administración de tu tienda en el menú lateral izquierdo, en Parámetros de la Tienda > Configuración, desplázate hasta el final y elige una Actividad Principal para tu tienda, después haz clic en "Guardar".
  Este paso no es obligatorio, pero no seleccionar una Actividad Principal puede hacer que tu tienda se compare con todas las demás tiendas de cualquier sector en Data Lab, proporcionando datos menos valiosos para ti, por lo que te lo recomendamos encarecidamente.

#### Guía de instalación rápida

- Descarga el archivo <a href="https://datalab-static-files-pro-3f9vom6e.s3.eu-west-1.amazonaws.com/connectors/prestashop/datalab_connector.zip" download target="_blank" rel="noopener noreferrer">datalab_connector.zip</a> en algún lugar accesible desde el ordenador de tu tienda
- Abre el Panel de Administración de Prestashop
- Ve a Módulos > Gestión de Módulos
- Haz clic en "Subir un Módulo" en la esquina superior derecha
- Selecciona o arrastra tu archivo datalab_connector.zip
- Haz clic en "Configurar"
- Haz clic en el enlace proporcionado, te enviará a Data Lab
- Si no has iniciado sesión, inicia sesión en Data Lab. Si no tienes una cuenta, primero debes registrarte.
- El enlace te mostrará un resumen de los datos de tu tienda en Data Lab; si es correcto, haz clic en "Aceptar". Puedes cerrar la pestaña o volver a la configuración del módulo en el Panel de Administración de Prestashop.
- Por último, pulsa el botón "Validar" para comprobar si la instalación se completó correctamente.
`,

  en: `
## Data Lab Connector User Guide

### What does the Data Lab connector do?

- The Data Lab Connector access your store's prestashop database to retrieve daily simple traffic metrics and ecommerce events.
- All data is fully processed and anonimized by the module before it can leave your store, ensuring no sensitive data leaves your shop at any point in the process.
- Once connected to Data Lab, you can analize your metrics in the platform to have a better understanding of your own store and its sales: find at what times you sell the most, where you commonly ship or compare at which point on the year your carts are better translated into sales.
- You can revoke access at any point in time you desire. Your store, your freedom.

#### Who can see my data from Data Lab?

Your store's data is yours only to see, Data Lab only shows three types of data to its users:

- Their personal data (their own store's, no one else can see it)
- Public data (from publicly available sources, everyone can see it)
- Aggregations: once we have a considerable amount of sources and the data cannot be traced back in any way, Data Lab performs aggregations so anyone can compare themselves to the rest of their industry in a private. Any user contributing to an aggregation can see the aggregated data, but never one store's (except their own).

#### Before you install

- Make sure to be registered in Data Lab.
- For your store's metrics to accurately compare to your industry's aggregated, you can set a Main Activity for your store before installing the module.
  You can find this configuration in your store's admin panel on the leftside menu, in Store Parameters > Configuration, scroll all the way down and choose a Main Activity for your store, then click on "Save".
  This step isn't mandatory, but not selecting a Main Activity may cause your store to be compared to all other stores of any industry or activity in Data Lab, providing less valuable data for you, so we highly recommend it.

#### Quick installation guide

- Download the <a href="https://datalab-static-files-pro-3f9vom6e.s3.eu-west-1.amazonaws.com/connectors/prestashop/datalab_connector.zip" download target="_blank" rel="noopener noreferrer">datalab_connector.zip</a> file somewhere accessible in your store's computer
- Open your Prestashop's Admin Panel
- Go to Modules > Module Management
- Click "Upload a Module" on the upper right corner
- Select or drag your datalab_connector.zip file
- Click "Configure"
- Click on the Link provided, it will send you to Data Lab
- If you aren't logged in, log into Data Lab. If you don't have an acoount, you must register first.
- The link will show you a summary of your store data in Data Lab, if it's correct, click "Accept". You can close the tab or return to the module configuration in Prestashop's Admin Panel
- Lastly, press the "Validate" button to check if your installation was completed successfully
`
}
